/**
 * @description 业务配置
 **/
const business = {
  grade: ['小小班', '小班', '中班', '大班'],
  classType: ['美萃班', '美创班', '两者均可'],
  education: ['博士研究生', '硕士研究生', '本科', '大专', '高中', '中专', '初中', '小学'],
  town: ['北滘镇', '陈村镇', '伦教街道', '大良街道', '乐从镇', '容桂镇', '勒流镇', '均安镇', '杏坛镇', '龙江镇', '其他地区'],
  sex: ['男', '女'],
  isEmployee: ['是', '否'],
  isBusing: ['是', '否'],
  isParentingClass: ['是', '否'],
  isInSchool: ['是', '否']
}
module.exports = business
